export const colors = {
  theme: JSON.parse(localStorage.getItem("themeData"))?.CustomData?.PrimaryColor1,
  green: "#7EFFAA",
  blushGreen: "#34FB69",
  darkGreen: "#1eb942",
  purple: "#A07EFF",
  red: "#FF7EB5",
  orange: "#FFC37E",
  darkOrange: "#FB9F34",
  lightOrange: "#D4B257",
  blue: "#4166F8",
  mattBlue: "#7E9BFF",
  lightBlue: "#43CFE5",
};
